const s = {
  name: "StackOfCreditCards2",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M35,21h-6v-2h6V21z"/>
		<path class="st0" d="M21,21h6v-2h-6V21z"/>
		<path class="st0" d="M19,21h-6v-2h6V21z"/>
		<path class="st0" d="M5,21h6v-2H5V21z"/>
		<path class="st0" d="M5,9h7v7H5V9z M7,11v3h3v-3H7z"/>
		<path class="st0" d="M0,5c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v16c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5z M5,2C3.3,2,2,3.3,2,5v16
			c0,1.7,1.3,3,3,3h30c1.7,0,3-1.3,3-3V5c0-1.7-1.3-3-3-3H5z"/>
		<path class="st0" d="M0,30h40v-2H0V30z"/>
		<path class="st0" d="M40,34H0v-2h40V34z"/>
		<path class="st0" d="M0,38h40v-2H0V38z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as StackOfCreditCards2
};
